import { render, staticRenderFns } from "./kot-receipt.vue?vue&type=template&id=37a72a01"
import script from "./kot-receipt.vue?vue&type=script&lang=js"
export * from "./kot-receipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports